import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ROUTES } from '@/common';
import { useBreadcrumbs } from '@/modules/core/hooks';
import SelfDirectedAllocation from '@/modules/investments/SelfDirected/SelfDirectedAllocation';
import { useMyEnrollments } from '@/modules/transaction';
import { useQueryParams } from '@/utils';

const INVESTOR_ID_QUERY = 'investorId';
const SelfDirectedDistributionPage = () => {
  const { t } = useTranslation();
  const { accountId = '' } = useParams<{ accountId: string }>();
  const query = useQueryParams();
  const investorId = useMemo(() => query.get(INVESTOR_ID_QUERY), [query]);
  
  
  const { currentMyAccount } = useMyEnrollments(accountId);
  useBreadcrumbs([{
    key: ROUTES.HOME,
    title: t('Home'),
    value: ROUTES.HOME,
  },
  {
    key: ROUTES.MY_ACCOUNTS_DETAILS(currentMyAccount?.id),
    title: currentMyAccount?.accountType,
    value: ROUTES.MY_ACCOUNTS_DETAILS(currentMyAccount?.id),
  },
  {
    key: ROUTES.START_INVESTING,
    title: t('Start Investing'),
    value: ROUTES.START_INVESTING,
  }], true);
  if (!accountId) {
    return null;
  }
  return (
    <SelfDirectedAllocation accountId={accountId} investorId={`${investorId || ''}`} />
  );
};
export default SelfDirectedDistributionPage;